import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { useWelcomeModalStore } from './hooks/WelcomeModalStore';

function WelcomeModal() {
  const { isOpen: isWelcomeModalOpen, onWelcomeClose: closeWelcomeModal, onCheckModalOpen } = useWelcomeModalStore();

  return (
    <div>
      <Modal isOpen={isWelcomeModalOpen} size="lg" backdrop="static" keyboard={false}>
        <ModalHeader className="d-flex justify-content-center">
          <span className="text-purple fs-1 fw-bold font-style-Century-Gothic">Welcome</span>
        </ModalHeader>
        <ModalBody>
          <div className="row fw-normal fs-5 font-style-Century-Gothic">
            <div className="col-12">
              This system is here to explore ways to make daily work lighter - less routine, more clarity, fewer
              unnecessary checks over time.
            </div>
            <div className="col-12 pt-3">Take your time.</div>
            <div className="col-12 pt-3">
              You’re taking part in an early testing phase - helping us learn, together, how clearer signals and
              workflows lead to better outcomes for your team and your clients.
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-center">
          <button
            className="btn-modal-welcome"
            onClick={() => {
              onCheckModalOpen();
              closeWelcomeModal();
            }}
          >
            <span className="text-modal-welcome">Continue</span>
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default WelcomeModal;
